import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import DefaultData from '../../CompanyData/DefaultData';

export default function PublicHeader() {
  const navLinkStyle = {
    textDecoration: 'none',
    color: DefaultData.THEMECOLOR2,
    margin: '0 1.5rem',
    fontWeight: '500',
    fontSize: '1rem',
    padding: '0.5rem 0',
    transition: 'color 0.2s ease',
  };

  const activeNavLinkStyle = { ...navLinkStyle, color: '#000000' };

  return (
    <header className="py-3 bg-white shadow-sm sticky-top">
      <div className="container-fluid d-flex justify-content-between align-items-center px-4">
        <Link to="/" className="text-decoration-none">
          <img src="/assets/images/Zotrai.png" alt={`${DefaultData.DEFAULTBRANDNAME} Logo`} style={{ height: '35px' }} />
        </Link>
        <nav className="d-none d-lg-flex align-items-center">
          <NavLink to="/about" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>About Zotrai</NavLink>
          <NavLink to="/supplierregister" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>Global API Suppliers</NavLink>
          <NavLink to="/dmcregister" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>Global DMCS</NavLink>
          <NavLink to="/visaregister" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>Visa Providers</NavLink>
        </nav>
        <div className="d-flex align-items-center gap-3">
          <Link 
            to="/register" 
            className="btn px-4" 
            style={{ backgroundColor: DefaultData.THEMECOLOR1, color:DefaultData.THEMECOLOR3 }}>
            Agent Registration
          </Link>
        </div>
      </div>
    </header>
  );
};